import {
  SELLING_PLAN_GROUP_ADDON_TAG,
  SELLING_PLAN_GROUP_HIDDEN_TAG,
  SELLING_PLAN_GROUP_TRENDING_LISTS_TAG,
} from "../../constants";
import { shopifyGidToNumber } from "../../utils/ensureShopifyGid";

import { ISmartrrSellingPlanGroup } from ".";
import { IPurchasable } from "../Purchasable";

import { SellingPlanGroupInterface } from "./SellingPlanGroupInterface";

export default class SellingPlanGroup implements SellingPlanGroupInterface {
  private readonly data: ISmartrrSellingPlanGroup;

  public constructor(data: ISmartrrSellingPlanGroup) {
    this.data = data;
  }

  public getProductIds(): number[] {
    return this.data.productIds;
  }

  public isAddon(): boolean {
    return this.data.name.includes(SELLING_PLAN_GROUP_ADDON_TAG);
  }

  public isHidden(): boolean {
    return this.data.name.includes(SELLING_PLAN_GROUP_HIDDEN_TAG);
  }

  public isTrendingList(): boolean {
    return this.data.name.includes(SELLING_PLAN_GROUP_TRENDING_LISTS_TAG);
  }

  public isVisible(): boolean {
    return !this.isAddon() && !this.isHidden() && !this.isTrendingList();
  }

  public coversProduct(purchasable: IPurchasable): boolean {
    if (!purchasable.shopifyId) {
      return false;
    }

    return this.getProductIds().includes(shopifyGidToNumber(purchasable.shopifyId));
  }

  public getHandleForProduct(purchasable: IPurchasable): string | undefined {
    if (!purchasable.shopifyId) {
      return undefined;
    }

    return this.data.productHandles?.[shopifyGidToNumber(purchasable.shopifyId)];
  }
}
